
export enum TabularSize {
    Default,
    Small,
    Large
}